// removed by extract-text-webpack-plugin
module.exports = {"materialize-textarea":"SettingsTabs__materialize-textarea___1yVBy","modal-2463794813":"SettingsTabs__modal-2463794813___2f-s3","container":"SettingsTabs__container___2g6d0","activeClass":"SettingsTabs__activeClass___5fIXx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SettingsTabs/SettingsTabs.scss
// module id = 1532
// module chunks = 0